<template>
  <div>
    <section class="section section-products">
      <div class="container">
        <div class="row">
          <div class="col">
            <h2>{{ title }}</h2>
            <p>
              Browse our range of products below and don't hesitate to contact us if you have an enquiry. If you're not sure what you are looking for, check out our
              <a href="/product-selection-tool.pdf">Product Selection Tool.</a>
            </p>
          </div>
        </div>
        <div class="row mt-3 mb-3">
          <div class="col">
            <div class="row">
              <div class="col-sm-6 pr-sm-1">
                <multiselect
                  v-model="selectedBrands"
                  placeholder="Brand"
                  label="name"
                  track-by="id"
                  :options="sortedBrands"
                  :multiple="true"
                ></multiselect>
              </div>
              <div class="col-sm-6 pl-sm-1">
                <multiselect
                  class="mt-3 mt-sm-0"
                  v-model="selectedSubcategories"
                  placeholder="Category"
                  label="name"
                  track-by="id"
                  :options="sortedSubcategories"
                  :multiple="true"
                ></multiselect>
              </div>
              <div class="col-12 pt-0 pt-sm-2">
                <div class="form-group">
                  <div class="input-group products-search-form-group mt-3 mt-sm-0">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="ni ni-zoom-split-in"></i>
                      </span>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Search"
                      type="text"
                      v-model="searchInput"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row pt-3">
          <div class="col product-list">
            <div class="row">
              <div class="col-12 col-sm-6 pb-5" v-for="product in sortedProducts" :key="product.id">
                <div class="product">
                  <img :src="`https://www.arctec.ie/static/img/product/${product.productId}.jpg`" />
                  <h3 class="text-primary text-uppercase">{{ product.name }}</h3>
                  <span class="d-none">{{product.description}}</span>
                  <a
                    :href="'mailto:sales@arctec.ie?Subject=Website%20enquiry: ' + product.name + '&body=Website Enquiry - Product: ' + product.name"
                    rel="noopener"
                    target="_blank"
                    class="btn btn-primary btn-icon"
                  >
                    <span class="btn-inner--icon">
                      <i class="fa fa-envelope mr-2"></i>
                    </span>
                    <span class="nav-link-inner--text">Enquire</span>
                  </a>
                  <a
                    :href="`https://www.arctec.ie/static/catalogues/${product.productId}.pdf`"
                    rel="noopener"
                    target="_blank"
                    class="btn btn-secondary btn-icon"
                  >
                    <span class="btn-inner--icon">
                      <i class="fa fa-download mr-2"></i>
                    </span>
                    <span class="nav-link-inner--text">View PDF</span>
                  </a>
                </div>
              </div>
              <div class="col-12" v-if="!filteredProducts.length">
                <p class="text-muted">No products found.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import { Breadcrumb } from "bootstrap-vue";
import Multiselect from "vue-multiselect";
import Fuse from "fuse.js";

export default {
  components: {
    Breadcrumb,
    Multiselect
  },
  data() {
    const { categoryId } = this.$route.params;

    return {
      breadcrumbs: [
        {
          text: "Products"
        },
        {
          text: categoryId,
          href: `#/products/${categoryId}`,
          active: true
        }
      ],
      selectedBrands: [],
      selectedSubcategories: [],
      searchInput: ""
    };
  },
  methods: {
    ...mapActions([
      "fetchBrands",
      "fetchCategories",
      "fetchProducts",
      "fetchSubcategories"
    ])
  },
  mounted() {
    this.fetchCategories();
    this.fetchProducts();
    this.fetchBrands();
    this.fetchSubcategories();
  },
  computed: {
    ...mapGetters(["categories", "productsList", "brands", "subcategories"]),
    category() {
      return this.categories[this.$route.params.categoryId] || {};
    },
    title() {
      return this.$route.params.categoryId ? this.category.name : "Products";
    },
    products() {
      const { categoryId } = this.$route.params;

      return categoryId
        ? _.filter(this.productsList, product =>
            _.includes(product.categoryIds, this.category.id)
          )
        : this.productsList;
    },
    filteredProducts() {
      const { products, selectedBrands, selectedSubcategories } = this;
      let _filteredProducts = [...products];

      if (_.filter(selectedBrands).length) {
        _filteredProducts = _.filter(_filteredProducts, product =>
          _.some(product.brandIds, id => _.some(selectedBrands, { id }))
        );
      }

      if (_.filter(selectedSubcategories).length) {
        _filteredProducts = _.filter(_filteredProducts, product =>
          _.some(product.subcategoryIds, id =>
            _.some(selectedSubcategories, { id })
          )
        );
      }

      return _filteredProducts;
    },
    searchedProducts() {
      const { searchInput, filteredProducts } = this;
      const fuse = new Fuse(filteredProducts, {
        shouldSort: true,
        threshold: 0.1,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: ["name", "description"]
      });
      return searchInput === "" ? filteredProducts : fuse.search(searchInput);
    },
    sortedProducts() {
      return _.sortBy(this.searchedProducts, "name");
    },
    brandIds() {
      return _.reduce(
        this.products,
        (ids, product) => _.union(ids, product.brandIds),
        []
      );
    },
    sortedBrands() {
      const brands = _.map(this.brandIds, id => this.brands[id]);
      return _.sortBy(brands, "name");
    },
    subcategoryIds() {
      return _.reduce(
        this.products,
        (ids, product) => _.union(ids, product.subcategoryIds),
        []
      );
    },
    sortedSubcategories() {
      const subcategories = _.map(
        this.subcategoryIds,
        id => this.subcategories[id]
      );
      return _.sortBy(subcategories, "name");
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.product-filters h3 {
  color: #666666;
  font-size: 11px;
  font-weight: 700;
}

.product-filters hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.product-filters-list {
  overflow: auto;
  max-height: 270px;
  display: block;
}

.products-search-form-group {
  margin-bottom: 0;
  // border-radius: 5px;
  // border: 1px solid #e8e8e8 !important;

  .input-group-text {
  }

  .form-control {
    height: 43px;
  }
}
.product {
  margin-bottom: 30px;
  img {
    height: 250px;
  }
  h3 {
    font-size: 1.33em;
    padding-top: 1em;
  }
}
</style>
